// dependencies
import { Map, List } from "immutable";
import { GenerateProcess } from "redux-process";

// config
import config from "./config";

// ui
import ui from "./ui";

// actions
import { updateUI } from "Actions/ui";

// selectors
import { getPageName, getUI } from "Selectors/ui";
import { getAuthorValue, getCompanyValue, getReportID } from "./selectors";

export const changeUI = (keyPath, value) => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);
	const newKeyPath = [pageName].concat(keyPath);

	dispatch(updateUI(newKeyPath, value));
};

export const searchSnapshots = () => async (dispatch, getState) => {
	const state = getState();
	const currentUI = getUI(state);

	const reviewReport = getReportID(state);
	const author = getAuthorValue(state).get("userID", "");
	const company = getCompanyValue(state).get("companyID", "");

	if (reviewReport === "" && author === "" && company === "") {
		return;
	}

	const request = await dispatch(
		GenerateProcess("getReviewReportsWithSnapshots", {
			author,
			company,
			reviewReport,
			sort: "-start_time",
			limit: config.pageSize,
			skip: (currentUI.get("currentPage", "") - 1) * config.pageSize,
		})
	);

	dispatch(changeUI(["reviewReports"], request.response.get("snapshots")));
};

export const updateInput = (name, value) => (dispatch) => {
	dispatch(changeUI([name], value));
	dispatch(searchSnapshots());
};

export const changePage = (page) => (dispatch) => {
	dispatch(changeUI(["currentPage"], page));
	dispatch(searchSnapshots());
};

export const updateReportIDInput = (value) => (dispatch, getState) => {
	const nextState = getUI(getState()).withMutations((mutable) => {
		// mutable.setIn(['author'], Map());
		// mutable.setIn(['company'], Map());
		mutable.setIn(["reportID"], value);
	});

	dispatch(changeUI([], nextState));
};

export const searchUsers = (value) => async (dispatch) => {
	const request = await dispatch(GenerateProcess("GetUsers", { q: value }));

	if (request.succeeded) {
		return request.response
			.map((item) => ({
				userID: item.get("id"),
				userName: item.get("name"),
				label: item.get("name"),
				companyID: item.get("company"),
				companyName: item.get("companyName"),
			}))
			.toJS();
	}

	return [];
};

export const searchCompanies = (value) => async (dispatch) => {
	const request = await dispatch(GenerateProcess("CompaniesSearch", { q: value }));

	if (request.succeeded) {
		return request.response
			.get("companies", List())
			.map((item) => ({
				companyID: item.get("id"),
				companyName: item.get("name"),
				label: item.get("name"),
			}))
			.toJS();
	}

	return [];
};

export const init = () => (dispatch) => {
	dispatch(changeUI([], ui));
	dispatch(searchSnapshots());
};
